import App from './App.svelte';

const app = new App({
	target: document.body,
	props: {
		config: {
			// model_root: 'http://localhost/projects/pagels_garten/',
			// application_root: 'http://localhost/projects/',
			model_root: 'https://dorfladen-gungolding.de/admin/model/',
			application_root: 'https://dorfladen-gungolding.de/admin/'
		}
	}
});

export default app;
